<template>
  <div class="layout-center-wrap">
    <div class="page-tit__wrap type-center">
      <h1 class="page-tit__sub">제조사 담당자</h1>
      <h2 class="page-tit">회원가입</h2>
    </div>

    <div class="join_notice_box">
      <button
        type="button"
        class="btn btn--darker_blue btn--m"
        v-on:click="openModal"
      >
        신규 제조사 추가 신청
      </button>
      원하는 제조사가 없을 경우, 신규 제조사 추가 신청후 회원가입을 진행해
      주시길 바랍니다.
    </div>
    <h3 class="section-title">담당자 정보 입력</h3>
    <table class="form-table type-block--mobile">
      <caption>
        회원가입을 위한 제조사 담당자 정보 입력 표
      </caption>
      <tbody>
        <tr>
          <th scope="row">
            제조사 <span class="svg_icon icon_must" aria-hidden="true"></span
            ><span class="sr-only">필수입력</span>
          </th>
          <td>
            <label for="pw" class="sr-only">제조사 입력</label>
            <select v-model="signupInfo.makrCode">
              <option :value="null">선택하세요</option>
              <option
                v-for="code in makrCodes"
                v-bind:key="code.cd"
                :value="code.cd"
              >
                {{ code.cdNm }}
              </option>
            </select>
          </td>
        </tr>
        <tr>
          <th scope="row">
            아이디 <span class="svg_icon icon_must" aria-hidden="true"></span
            ><span class="sr-only">필수입력</span>
          </th>
          <td>
            <div class="layout-flex-row">
              <label for="id" class="sr-only"
                >아이디(6~20자 대/소문자 입력)</label
              >
              <input
                type="text"
                id="id"
                placeholder="아이디(6~20자 대/소문자 입력)"
                class="form-table__input"
                v-model="signupInfo.userId"
                v-on:change="isIdDuplicate = false"
              />
              <button
                type="button"
                class="btn btn--m"
                v-on:click="checkIdDuplicate"
                :class="isIdDuplicate ? 'btn--gray' : 'btn--medium_blue'"
              >
                중복확인
              </button>
            </div>
          </td>
        </tr>
        <tr>
          <th scope="row">
            비밀번호<span class="svg_icon icon_must" aria-hidden="true"></span
            ><span class="sr-only">필수입력</span>
          </th>
          <td>
            <label for="pw" class="sr-only">비밀번호 입력</label>
            <input
              type="password"
              id="pw"
              placeholder="비밀번호를 설정하십시오(숫자, 영문, 특수문자를 1개이상 8~20자리 이내로 입력)"
              v-model="signupInfo.userPw"
            />
          </td>
        </tr>
        <tr>
          <th scope="row">
            비밀번호 확인
            <span class="svg_icon icon_must" aria-hidden="true"></span
            ><span class="sr-only">필수입력</span>
          </th>
          <td>
            <label for="pw-new" class="sr-only">비밀번호 재입력</label>
            <input
              type="password"
              id="pw-new"
              v-model="checkPassword"
              placeholder="비밀번호 확인을 입력하십시오"
            />
          </td>
        </tr>
        <tr>
          <th scope="row">
            이름 <span class="svg_icon icon_must" aria-hidden="true"></span
            ><span class="sr-only">필수입력</span>
          </th>
          <td>
            <label for="name" class="sr-only">이름 입력</label>
            <input
              type="text"
              id="name"
              class="form-table__input"
              value="본인 인증 시 사용된 이름으로 가입됩니다."
              disabled
            />
          </td>
        </tr>
        <tr>
          <th scope="row">
            영문 이름 <span class="svg_icon icon_must" aria-hidden="true"></span
            ><span class="sr-only">필수입력</span>
          </th>
          <td>
            <label for="e-name" class="sr-only"
              >영문 이름 입력 : 영어만 가능</label
            >
            <input
              type="text"
              id="e-name"
              class="input"
              placeholder="영문이름을 입력하십시오"
              v-model="signupInfo.userEngName"
            />
          </td>
        </tr>
        <tr>
          <th scope="row">
            휴대전화 번호
            <span class="svg_icon icon_must" aria-hidden="true"></span
            ><span class="sr-only">필수입력</span>
          </th>
          <td>
            <label for="tel" class="sr-only">휴대전화 번호 입력</label>
            <input
              type="text"
              id="tel"
              class="form-table__input"
              value="본인 인증 시 사용된 휴대전화 번호로 가입됩니다."
              disabled
            />
          </td>
        </tr>
        <tr>
          <th scope="row">
            이메일
            <span class="svg_icon icon_must" aria-hidden="true"></span
            ><span class="sr-only">필수입력</span>
          </th>
          <td>
            <div class="layout-flex-row">
              <label for="email" class="sr-only">이메일 입력</label>
              <input
                type="text"
                id="email"
                class="form-table__input"
                placeholder="ex) example@google.com"
                :disabled="isAuthCode"
                v-model="authInfo.email"
              />
              <button
                type="button"
                class="btn btn--m"
                v-on:click="authEmail"
                :disabled="isAuthCode"
                :class="isAuthEmail ? 'btn--medium_gray' : 'btn--medium_blue'"
              >
                {{ swichAuthButtonName() }}
              </button>
            </div>
            <div v-if="isAuthEmail && !isAuthCode" class="layout-flex-row">
              <label for="code" class="sr-only">인증코드를 입력하십시오.</label>
              <input
                id="code"
                type="text"
                class="form-table__input"
                placeholder="인증코드를 입력하십시오."
                v-model="authInfo.authCode"
              />
              <span class="form-table__time">{{ formattedTime }}</span>

              <button
                type="button"
                class="btn btn--medium_blue btn--m"
                v-on:click="verifyAuthCode"
              >
                인증하기
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <fieldset class="section-pt">
      <legend class="section-title">
        개인정보 수집·이용 및 제3자 제공 위탁 동의
      </legend>
      <section class="agree__form">
        <article class="agree__all">
          <p>
            한국인터넷진흥원(KISA)은 「개인정보보호법」에 따라 사이버 보안
            취약점 정보 포털 서비스 제공을 위하여 아래와 같이 개인정보를
            수집·이용하며, 처리 위탁을 수행하고 있습니다.<br />
            내용을 확인하신 후 동의 여부를 선택하여 주시기 바랍니다
          </p>
          <label class="chk agree__chk"
            ><input type="checkbox" v-model="handleAgreeAll" />모두
            동의합니다.</label
          >
        </article>
        <article class="agree__container">
          <div class="agree__body terms__container">
            <p class="terms-tit">
              개인정보 수집·이용 동의
              <span class="sub">(필수)</span>
            </p>
            <p class="terms-content">
              - 수집·이용 목적 : 보안 취약점 신고 접수·처리 및 결과 안내, 인증서
              발급, 신고포상제 운영, 핵더챌린지 플랫폼 연동, 이용자 문의 응대<br />
            </p>
            - 수집·이용 항목 : 아이디, 비밀번호, 성명, 영문명, 휴대전화번호,
            이메일, 소속<br />
            - 보유·이용 기간 : 회원탈퇴 시 즉시 파기<br />
            - 동의 거부에 따른 불이익 : 동의를 거부할 수 있으나, 이 경우
            회원가입 및 서비스 이용이 제한됩니다.<br />
          </div>
          <div class="agree__footer">
            <p class="agree-label">개인정보 수집·이용에 동의합니다.</p>
            <div class="chk__wrap">
              <label class="chk chk--circle"
                ><input
                  type="radio"
                  name="agree1"
                  :value="false"
                  v-model="signupInfo.privacyAgree1"
                />동의안함</label
              >
              <label class="chk chk--circle"
                ><input
                  type="radio"
                  name="agree1"
                  :value="true"
                  v-model="signupInfo.privacyAgree1"
                />동의함</label
              >
            </div>
          </div>
        </article>

        <article class="agree__container">
          <div class="agree__body terms__container">
            <p class="terms-tit">
              개인정보 처리·위탁 동의
              <span class="sub">(필수)</span>
            </p>
            개인정보의 처리 위탁은 「개인정보보호법」제26조에 따라 아래와 같이
            수행됩니다.<br /><br />

            <div class="data-table__wrap">
              <table class="data-table">
                <caption class="sr-only">
                  제3자 제공 내역
                </caption>
                <colgroup>
                  <col style="width: 20%" />
                  <col style="width: 25%" />
                  <col />
                  <col style="width: 20%" />
                </colgroup>
                <thead>
                  <tr>
                    <th scope="col">위탁받는 자</th>
                    <th scope="col">위탁 업무</th>
                    <th scope="col">수집·이용 항목</th>
                    <th scope="col">수집·이용 기간</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>㈜지엔</td>
                    <td>보안 취약점 신고 포상제 운영 지원</td>
                    <td>아이디, 성명, 휴대전화번호, 이메일</td>
                    <td>회원 탈퇴 또는 위탁계약 종료 시 즉시 파기</td>
                  </tr>
                  <tr>
                    <td>NICE평가정보</td>
                    <td>본인인증 서비스</td>
                    <td>아이디, 성명, 휴대전화번호, 이메일</td>
                    <td>회원 탈퇴 또는 위탁계약 종료 시 즉시 파기</td>
                  </tr>
                  <tr>
                    <td>㈜루테스</td>
                    <td>보안 취약점 정보 포털 유지보수</td>
                    <td>아이디, 성명, 휴대전화번호, 이메일</td>
                    <td>회원 탈퇴 또는 위탁계약 종료 시 즉시 파기</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <br />
            - 동의 거부 시 불이익 : 위탁 동의를 거부할 수 있으나, 이 경우
            회원가입 및 서비스 이용이 제한됩니다.  
          </div>
          <div class="agree__footer">
            <p class="agree-label">개인정보 처리·위탁에 동의합니다.</p>
            <div class="chk__wrap">
              <label class="chk chk--circle"
                ><input
                  type="radio"
                  name="agree3"
                  :value="false"
                  v-model="signupInfo.privacyAgree3"
                />동의안함</label
              >
              <label class="chk chk--circle"
                ><input
                  type="radio"
                  name="agree3"
                  :value="true"
                  v-model="signupInfo.privacyAgree3"
                />동의함</label
              >
            </div>
          </div>
        </article>
      </section>
      <div class="btn__wrap type-bottom-board">
        <button
          type="button"
          class="btn btn--l btn--blue btn--m_full"
          v-on:click="signup"
        >
          회원가입
        </button>
      </div>
    </fieldset>

    <Modal
      :visible="isModal"
      :pop_tit="makrModalTitle"
      popSizeClass="popup__container--l"
      @close="closeModal"
    >
      <template #pop_content>
        <table class="form-table type-block--mobile">
          <tbody>
            <tr>
              <th scope="row">
                제조사명
                <span class="svg_icon icon_must" aria-hidden="true"></span
                ><span class="sr-only">필수입력</span>
              </th>
              <td>
                <div class="layout-flex-row">
                  <label for="id" class="sr-only"
                    >제조사명을 입력하십시오</label
                  >
                  <input
                    type="text"
                    id="id"
                    placeholder="제조사명을 입력하십시오"
                    class="form-table__input"
                    v-model="newMakrInfo.newMakrName"
                    v-on:change="isMakrNameDuplicate = false"
                  />
                  <button
                    type="button"
                    class="btn btn--m"
                    v-on:click="checkMakrNameDuplicate"
                    :class="
                      isMakrNameDuplicate ? 'btn--gray' : 'btn--medium_blue'
                    "
                  >
                    중복확인
                  </button>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row">
                국내여부 선택
                <span class="svg_icon icon_must" aria-hidden="true"></span
                ><span class="sr-only">필수입력</span>
              </th>
              <td>
                <label for="pw" class="sr-only">해외여부 선택</label>
                <select v-model="newMakrInfo.foreignYn">
                  <option value="N">국내</option>
                  <option value="Y">해외</option>
                </select>
              </td>
            </tr>
            <tr>
              <th scope="row">
                이메일
                <span class="svg_icon icon_must" aria-hidden="true"></span
                ><span class="sr-only">필수입력</span>
              </th>
              <td>
                <div class="layout-flex-row">
                  <label for="email" class="sr-only">이메일 입력</label>
                  <input
                    type="text"
                    id="email"
                    class="form-table__input"
                    placeholder="ex) example@google.com"
                    :disabled="isAuthCode"
                    v-model="authInfo.email"
                  />

                  <button
                    type="button"
                    class="btn btn--m"
                    v-on:click="authEmail"
                    :disabled="isAuthCode"
                    :class="
                      isAuthEmail ? 'btn--medium_gray' : 'btn--medium_blue'
                    "
                  >
                    {{ swichAuthButtonName() }}
                  </button>
                </div>

                <div v-if="isAuthEmail && !isAuthCode" class="layout-flex-row">
                  <label for="code" class="sr-only"
                    >인증코드를 입력하십시오.</label
                  >
                  <input
                    id="code"
                    type="text"
                    class="form-table__input"
                    placeholder="인증코드를 입력하십시오."
                    v-model="authInfo.authCode"
                  />
                  <span class="form-table__time">{{ formattedTime }}</span>

                  <button
                    type="button"
                    class="btn btn--medium_blue btn--m"
                    v-on:click="verifyAuthCode"
                  >
                    인증하기
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </template>
      <template #pop_buttons>
        <button
          type="button"
          class="btn btn--m btn--blue"
          @click="applySelection"
        >
          신청
        </button>
      </template>
    </Modal>
  </div>
</template>

<script>
import { useRouter, useRoute } from "vue-router";
import { inject, ref, onMounted, watch, computed } from "vue";
import { useStore } from "vuex";
import Modal from "@/component/Modal.vue";
import Auth from "./Auth.vue";
import dc from "@/component/DataChk.js";
import rsa from "@/component/RSAPublicKey.js";

export default {
  components: {
    Auth,
    Modal,
  },
  setup() {
    const axios = inject("axios");
    const lodash = inject("lodash");
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const showLoading = () => store.dispatch("loading/show");
    const hideLoading = () => store.dispatch("loading/hide");

    // data 정의
    const defaultsignupInfo = () => ({
      refId: "",
      role: "PATCH",
      userId: "",
      userPw: "",
      userEngName: "",
      email: "",
      makrCode: null,
      makrName: null,
      hasNewMakr: false,
      foreignYn: "N",
      privacyAgree1: null,
      privacyAgree3: null,
    });
    const defaultNewMakrInfo = () => ({
      foreignYn: "N",
      newMakrName: "",
    });
    const defaultAuthInfo = () => ({
      email: "",
      authCode: "",
    });
    const makrModalTitle = ref("신규 제조사 신청");
    const checkPassword = ref(null);
    const handleAgreeAll = ref(false);
    const isIdDuplicate = ref(false);
    const isNickNameDuplicate = ref(false);
    const signupInfo = ref(defaultsignupInfo());
    const newMakrInfo = ref(defaultNewMakrInfo());
    const authInfo = ref(defaultAuthInfo());
    const makrCodes = ref([]);
    const isModal = ref(false);
    const isMakrNameDuplicate = ref(false);
    const isAuthEmail = ref(false);
    const isAuthCode = ref(false);
    const isNewMakr = ref(false);
    const authTime = ref(300);
    let authTimeInterval = null;

    // methods 정의
    const applySelection = () => {
      if (!validateNewMakrName(newMakrInfo.value)) {
        return false;
      }
      if (!validateAuthInfo()) {
        return false;
      }
      if (!isAuthCode.value) {
        alert("신청전에 이메일 인증을 진행하여주십시오");
        return false;
      }
      alert("신규 제조사 신청이 완료 되었습니다.");
      makrModalTitle.value = "신규 제조사 신청 완료";
      isNewMakr.value = true;
      signupInfo.value.hasNewMakr = true;
      closeModal();
    };
    const openModal = () => {
      if (!isIdDuplicate.value) {
        alert("가입할 아이디를 입력 후 중복확인을 먼저 진행하십시오.");
        return;
      }
      isModal.value = true;
    };
    const closeModal = () => {
      isModal.value = false;
    };

    const checkMakrNameDuplicate = () => {
      isMakrNameDuplicate.value = false;
      if (!validateMakrName()) {
        return;
      }
      showLoading();
      axios
        .post("/core/pu/code/makr-vaild/get", {
          cdNm: newMakrInfo.value.newMakrName,
        })
        .then((res) => {
          if (res.data.resType === "RES_OK") {
            alert("사용 가능한 제조사명칭입니다.");
            isMakrNameDuplicate.value = true;
          } else {
            alert(res.data.resMsg);
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          hideLoading();
        });
    };

    const checkIdDuplicate = () => {
      isIdDuplicate.value = false;
      if (!validateId()) {
        return;
      }
      showLoading();

      axios
        .post("/core/pu/member/id-vaild/get", {
          userId: signupInfo.value.userId,
        })
        .then((res) => {
          if (res.data.resType === "RES_OK") {
            alert("사용 가능한 아이디입니다.");
            isIdDuplicate.value = true;
          } else {
            alert(res.data.resMsg);
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          hideLoading();
        });
    };

    const checkNickNameDuplicate = () => {
      isNickNameDuplicate.value = false;
      if (!dc.nullChk(signupInfo.value.userNickname)) {
        alert("닉네임을 입력하십시오.");
        return;
      }
      showLoading();

      axios
        .post("/core/pu/member/nickname-vaild/get", {
          userNickname: signupInfo.value.userNickname,
        })
        .then((res) => {
          if (res.data.resType === "RES_OK") {
            alert("사용 가능한 닉네임입니다.");
            isNickNameDuplicate.value = true;
          } else {
            alert(res.data.resMsg);
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          hideLoading();
        });
    };

    const validateMakrName = () => {
      if (!dc.nullChk(newMakrInfo.value.newMakrName)) {
        alert("제조사명을 입력하십시오.");
        return false;
      }
      return true;
    };
    const validateId = () => {
      if (!dc.nullChk(signupInfo.value.userId)) {
        alert("아이디를 입력하십시오");
        return false;
      } else if (
        signupInfo.value.userId.length < 6 ||
        signupInfo.value.userId.length > 20
      ) {
        alert("아이디는 6~20자 사이로 올바르게 입력하십시오.");
        return false;
      }

      return true;
    };

    const validateEmail = (email) => {
      if (!dc.nullChk(email)) {
        alert("이메일을 입력하십시오");
        return false;
      } else if (!dc.emailValidChk(email)) {
        alert("이메일을 정확하게 입력하십시오.\n입력예시) korea@kisa.co.kr");
        return false;
      }

      return true;
    };

    const validateNewMakrName = (info) => {
      if (!dc.nullChk(info.newMakrName)) {
        alert("신규 제조사명을 입력하십시오");
        return false;
      }

      if (!isMakrNameDuplicate.value) {
        alert("신규 제조사명 중복체크를 진행하십시오");
        return false;
      }

      return true;
    };
    const validateAuthInfo = () => {
      if (!validateId()) {
        return false;
      }
      if (!isIdDuplicate.value) {
        alert("아이디 중복체크를 진행해 주십시오.");
        return false;
      }

      if (!validateEmail(authInfo.value.email)) {
        return false;
      }
      return true;
    };

    const authEmail = () => {
      if (!validateAuthInfo()) {
        return false;
      }
      showLoading();
      axios
        .post("/core/pu/mail/verify/send", {
          userId: signupInfo.value.userId,
          userEmail: authInfo.value.email,
          recipientType: "MAKR",
        })
        .then((res) => {
          if (res.data.resType === "RES_OK") {
            isAuthEmail.value = true;

            alert(
              "인증메일을 전송하였습니다. 메일을 확인하신 후 인증코드를 입력하여 주십시오."
            );
            startTimer();
          } else {
            alert(res.data.resMsg);
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          hideLoading();
        });
    };

    const verifyAuthCode = () => {
      if (!dc.nullChk(authInfo.value.authCode)) {
        alert("인증코드를 입력하십시오.");
        return false;
      }
      showLoading();
      axios
        .post("/core/pu/mail/verify", {
          userId: signupInfo.value.userId,
          userEmail: authInfo.value.email,
          authCode: authInfo.value.authCode,
          recipientType: "MAKR",
        })
        .then((res) => {
          if (res.data.resType === "RES_OK") {
            isAuthCode.value = true;
            alert("인증되었습니다.");
            clearInterval(authTimeInterval);
          } else {
            alert(res.data.resMsg);
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          hideLoading();
        });
    };

    const validateSignupInfo = (info) => {
      if (!dc.nullChk(info.privacyAgree1) || !info.privacyAgree1) {
        alert("개인정보 수집·이용 동의 (필수) 항목에 동의하여 주십시오.");
        return false;
      }

      if (!dc.nullChk(info.privacyAgree3) || !info.privacyAgree3) {
        alert("개인정보 처리·위탁 동의 (필수) 항목에 동의하여 주십시오.");
        return false;
      }

      if (info.hasNewMakr) {
        if (!validateNewMakrName(newMakrInfo.value)) {
          return false;
        }
      } else {
        if (!dc.nullChk(info.makrCode)) {
          alert("제조사를 선택하십시오.");
        }
      }

      if (!validateId()) {
        return false;
      }

      if (!isIdDuplicate.value) {
        alert("아이디 중복체크를 진행해 주십시오.");
        return false;
      }

      if (!dc.nullChk(info.userPw)) {
        alert("비밀번호를 입력하십시오");
        return false;
      } else if (!dc.passwordCheck(info.userPw)) {
        alert(
          `비밀번호는 숫자, 영문, 특수문자를 1개이상 8~20자리 이내로 입력하십시오.`
        );
        return false;
      } else if (info.userPw !== checkPassword.value) {
        alert("입력하신 비밀번호와 비밀번호 확인이 일치하지 않습니다.");
        return false;
      }

      if (!dc.nullChk(info.userEngName)) {
        alert("영문 이름을 입력하십시오");
        return false;
      }

      if (!validateEmail(info.email)) {
        return false;
      }

      if (!isAuthCode.value) {
        alert("회원가입전에 이메일 인증을 진행하여주십시오");
        return false;
      }
      return true;
    };

    const encrptySignupInfo = (info) => {
      info.userId = rsa.encryptData(info.userId);
      info.userPw = rsa.encryptData(info.userPw);
      info.email = rsa.encryptData(info.email);
    };

    const signup = () => {
      const info = lodash.cloneDeep(signupInfo.value);
      info.email = lodash.cloneDeep(authInfo.value.email);
      if (info.hasNewMakr) {
        info.foreignYn = newMakrInfo.value.foreignYn;
        info.makrName = newMakrInfo.value.newMakrName;
      }
      if (!validateSignupInfo(info)) {
        return;
      }
      showLoading();
      //암호화
      encrptySignupInfo(info);
      axios
        .post("/core/pu/member/signup", info)
        .then((res) => {
          if (res.data.resType === "RES_OK") {
            axios.setErrorSession(1001);
          } else {
            axios.setErrorSession(1002, res.data?.resMsg);
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          hideLoading();
        });
    };

    const getMakrCodes = () => {
      axios
        .post("/core/pu/code/makr-codes/get", { depth: 1 })
        .then((res) => {
          if (res.data.resType === "RES_OK") {
            makrCodes.value = res.data.resList;
          }
        })
        .catch((error) => {
          console.error(error);
        });
    };

    const swichAuthButtonName = () => {
      if (!isAuthEmail.value && !isAuthCode.value) {
        return "인증메일 발송";
      } else if (isAuthEmail.value && !isAuthCode.value) {
        return "재전송";
      } else if (isAuthEmail.value && isAuthCode.value) {
        return "인증 완료";
      }
    };

    const startTimer = () => {
      // 기존 타이머 정리
      clearInterval(authTimeInterval);
      authTime.value = 300; // 초기화 (5분)

      authTimeInterval = setInterval(() => {
        authTime.value--;

        if (authTime.value <= 0) {
          clearInterval(authTimeInterval);
          alert("인증시간이 만료되었습니다.\n재인증 요청을 해주세요.");
          showAuthForm.value = false;
        }
      }, 1000);
    };

    // watch computed정의
    watch(handleAgreeAll, (newVal) => {
      const agree = newVal ? true : null;
      signupInfo.value.privacyAgree1 = agree;
      signupInfo.value.privacyAgree3 = agree;
    });

    // 시간 표시용 계산 속성
    const formattedTime = computed(() => {
      const min = Math.floor(authTime.value / 60)
        .toString()
        .padStart(2, "0");
      const sec = (authTime.value % 60).toString().padStart(2, "0");
      return `${min}:${sec}`;
    });

    // life cycle 정의
    onMounted(() => {
      if (!route.query.refId) {
        router.push("/");
        return;
      }
      signupInfo.value.refId = route.query.refId;

      rsa.getPublicKey();
      getMakrCodes();
    });

    // html에서 사용될 데이터 정의
    return {
      signupInfo,
      checkPassword,
      handleAgreeAll,
      isIdDuplicate,
      isNickNameDuplicate,
      isMakrNameDuplicate,
      checkIdDuplicate,
      checkNickNameDuplicate,
      signup,
      makrCodes,
      openModal,
      closeModal,
      isModal,
      newMakrInfo,
      checkMakrNameDuplicate,
      authEmail,
      isAuthEmail,
      isAuthCode,
      authTime,
      formattedTime,
      verifyAuthCode,
      makrModalTitle,
      applySelection,
      authInfo,
      swichAuthButtonName,
    };
  },
};
</script>